import OldArticleHero from "@components/elements/V2/OldArticleHero"
import React from "react"

const StoryblokOldArticleHero = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.OldArticleHero>) => {
  return (
    <OldArticleHero
      category={blok.category}
      title={blok.title}
      subscript={blok.subscript}
      backgroundColor={blok.backgroundColor}
      imageAlt={blok.image.alt}
      imageUrl={blok.image.filename}
      mobileGridOrder={mobileGridOrder}
    />
  )
}

export default StoryblokOldArticleHero
